<template>
    <div class="member">
        <div class="member__portrait" :style="{ backgroundImage: 'url(' + require(`../../assets/${portrait}.jpg`) + ')' }" @click="showModal"></div>
        <span class="member__name" @click="showModal">{{ name }}</span>
        <span class="member__position" @click="showModal">{{ position }}</span>
        <ul class="member__links" @click="showModal">
            <li v-for="(link, name) in links" :key="link">
                <span v-if="'email' === name" :class="'member__link member__link--' + name">
                    <FontAwesomeIcon :icon="'paper-plane'" />
                </span>
                <span v-if="'phone' === name" :class="'member__link member__link--' + name">
                    <FontAwesomeIcon :icon="'phone'" />
                </span>
                <span v-if="'linkedin' === name" :class="'member__link member__link--' + name">
                    <FontAwesomeIcon :icon="['fab', 'linkedin-in']" />
                </span>
            </li>
        </ul>
        <Modal v-show="isModalVisible" @close="closeModal">
            <template v-slot:header>
                <div class="portrait" :style="{ backgroundImage: 'url(' + require(`../../assets/${portrait}.jpg`) + ')' }"></div>
                <div class="name">{{ name }}</div>
                <div class="position">{{ position }}</div>
            </template>
            <template v-if="text !== undefined" v-slot:body>
                <p>{{ text }}</p>
            </template>
            <template v-slot:footer>
                <ul class="member__links">
                    <li v-for="(link, name) in links" :key="link">
                        <a v-if="'email' === name" :href="'mailto:' + link" :class="'member__link member__link--' + name">
                            <FontAwesomeIcon :icon="'paper-plane'" />
                            <span>{{ link }}</span>
                        </a>
                        <a v-if="'phone' === name" :href="'tel:' + link" :class="'member__link member__link--' + name">
                            <FontAwesomeIcon :icon="'phone'" />
                            <span>{{ link }}</span>
                        </a>
                        <a v-if="'linkedin' === name" :href="link" :class="'member__link member__link--' + name" target="_blank">
                            <FontAwesomeIcon :icon="['fab', 'linkedin-in']" />
                            <span>{{ link }}</span>
                        </a>
                    </li>
                </ul>
            </template>
        </Modal>
    </div>
</template>

<script>
    import Modal from './Modal.vue';
    import { library } from '@fortawesome/fontawesome-svg-core'; 
    import { faPaperPlane, faPhone } from '@fortawesome/free-solid-svg-icons';
    import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    library.add(faPaperPlane);
    library.add(faPhone);
    library.add(faLinkedinIn);

    export default {
        name: 'Member',
        props: {
            portrait: String,
            name: String,
            position: String,
            links: Object,
            text: String
        },
        components: {
            Modal,
            FontAwesomeIcon
        },
        data() {
            return {
                isModalVisible: false
            }
        },
        methods: {
            showModal() {
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .member {
        width: 100%;
        text-align: center;
        cursor: pointer;

        &__portrait {
            width: 16rem;
            height: 16rem;
            border-radius: 50%;
            margin: 0 auto;
            background-size: cover;
            box-shadow: 10px -10px #fad2ca54, -10px 10px #375dad29;
            transition: all .15s ease-in-out;
        }

        &__name {
            display: block;
            width: 100%;
            margin-top: 3rem;
            font-family: 'Roboto Slab', sans-serif;
            font-size: 2rem;
            font-weight: 600;
            transition: color .15s ease-in-out;
        }

        &__position {
            display: block;
            width: 100%;
            margin-top: .5rem;
            font-size: 1.4rem;
            font-weight: 600;
            color: #666;
            transition: color .15s ease-in-out;
        }

        &__links {
            display: flex;
            justify-content: center;
            padding: 0;
            margin-top: 2rem;
            list-style-type: none;

            li {
                margin: 0 .5rem;
            }
        }

        &__link {
            display: block;
            width: 3rem;
            height: 3rem;
            border-radius: 50%;
            line-height: 3.1rem;
            font-size: 1.3rem;
            background-color: #333;
            color: #fff;

            svg path {
                color: #fff;
            }

            .fa-paper-plane {
                margin-left: -1px;
            }
        }

        &:hover {

            .member {

                &__portrait {
                    box-shadow: 10px -10px #fad2ca, -10px 10px #375dad;
                }

                &__name {
                    color: #375dad;
                }

                &__position {
                    color: #333;
                }
            }
        }
    }

    .modal {

        .member {

            &__links {
                display: block;

                li:not(:last-of-type) {
                    margin-bottom: 1rem;
                }
            }

            &__link {
                display: flex;
                align-items: center;
                width: auto;
                background-color: transparent;

                svg {
                    width: 3rem;
                    height: 3rem;
                    padding: .8rem;
                    border-radius: 50%;
                    margin-right: 1rem;
                    background-color: #333;
                }
            }
        }
    }

</style>